<template>
  <Menubar>
    <template #start>
        <span class="font-bold ml-2 text-2xl">{{title}}</span>
    </template>
    <template #end>
        <Link v-if="back_url && !back_url_param" :href="parsed_back_url"><Button label="Kembali" class="p-button-secondary p-button-sm" icon="pi pi-caret-left"> </Button> </Link>
        <Link v-if="back_url && back_url_param" :href="route(back_url,back_url_param)"><Button label="Kembali <" class="p-button-secondary p-button-sm" icon="pi pi-caret-left"> </Button> </Link>
    </template>
</Menubar>
</template>

<script>
import InputText from "primevue/inputtext";
import Menubar from "primevue/menubar";
import Button from "primevue/button";
import { Link } from '@inertiajs/inertia-vue3'


export default {
    components: {
        InputText,
        Menubar,
        Button,
        Link,
    },
    props: {
        title : String,
        back_url : String,
        back_url_param : Object
    },
    computed : {
        parsed_back_url() {
            // replace . with /
            return '/' + this.back_url.replace(/\./g, '/');
        }
    }
}
</script>

<style>

</style>